import React from "react";

const Faqs = () => {
  return (
    <div>
      <div className="container py-5 my-5">
        <div className="row">
          <div className="col md-6"></div>
          <h1>FAQs</h1>
          <h4>Envíos</h4>
          <p>
            Realizamos envíos a a todo el país. El tiempo de entrega varía entre 1 a 5 días, dependiendo de la disponibilidad y de dónde quieras recibir el producto.
          </p>
          <h4>Cuidados</h4>
          <p>
            Nuestras riñoneras son hechas a mano, con mucha dedicación y cariño. Su cuidado debe ser igual, mantenelas siempre libre de líquidos que puedan dañar el ecocuero.
          </p>
          <h4>ShowRoom</h4>
          <p>
           Tenemos dos showrooms. Podés coordinar con nosotras y venir a verlas. Estamos en Villa Crespo y en Tortuguitas.
          </p>
          <h4>Medios de Pago</h4>
          <p>
           Aceptamos efectivo, transferencias bancarias, depósitos, Mercado Pago, tarjeta de débito y con tarjeta de crédito tenés 3 cuotas sin interés.
          </p>
       
      </div>
      </div>
    </div>
  );
};

export default Faqs;
